module Tapas.ViewModels {

    export class MasterViewModel extends Ftw.ViewModels.BaseViewModel {
        public LoginViewModel = new Tapas.ViewModels.LoginViewModel;

        public menuOpen = ko.observable<boolean>(false);
        public customerTypeCookie = ko.observable(false);
        public load: KnockoutObservable<Load>;
        public data: Ftw.Data;
        public showNewsletterWidget: KnockoutObservable<boolean>;
        public newsletterModal: KnockoutObservable<boolean> = ko.observable(false);
        public newsletterSubscriptionStatus = ko.observable(false);
        public newsMagazineSubscription: KnockoutObservable<boolean> = ko.observable(false);
        public newsletterFormID: KnockoutObservable<string> = ko.observable('');
        public newsletterSubmitting: KnockoutObservable<boolean> = ko.observable(false); //  this stops the user clicking twice on the submit btn when is submitting
        public showResponsiveMenu = ko.observable(false);
        public responsive: KnockoutObservable<boolean>;
        public windowWidth = ko.observable($(window).width());
        public UserDataService = new Ftw.Dataservice.UserDataservice();
        public User = Ftw.Core.InstanceManager.get<Ftw.Dto.User>('User');
        public miniCartVisible = ko.observable(false)
         
        constructor() {
            super();
            
            this.showcustomerTypeCookieWarning();
            this.showNewsletterWidgetAfterDelay();
            this.load = ko.observable<Load>(new Load());
            this.data = new Ftw.Data();
            this.showNewsletterWidget = ko.observable(false);
            this.UserDataService.GetCurrent();

            Ftw.Events.cartLineAdded.subscribe((args) => {
                if (this.menuOpen()) {
                    this.miniCartVisible(false);
                } else {
                    this.miniCartVisible(true);
                    this.menuOpen(true);
                }
            });

            $(window).resize(() => {
                this.windowWidth($(window).width());
            });

            this.responsive = ko.computed({
                owner: this,
                read: () => {
                    return this.windowWidth() <= 991 ? true : false;
                }
            });
        }

        public closeMenu = () => {
            if (this.menuOpen()) {
                $(".item.visible").removeClass('visible');
                this.menuOpen(false);
                this.miniCartVisible(false);
            }
        }

        public showcustomerTypeCookieWarning = () => {
            if (document.cookie.indexOf('CustomerType') == -1) {
                $('.js-customer-type-modal').modal('show');
            }
        }

        public showNewsletterWidgetAfterDelay = () => {
            if (!localStorage.getItem("newsletterHide")) {
                setTimeout(() => {
                    this.showNewsletterWidget(true);
                }, 10000);
            }
        }

        public hideNewsletterWidget = () => {
            localStorage.setItem("newsletterHide", "1");
            this.toggleNewsletterWidget()
        }

        public toggleNewsletterWidget = () => {
            this.showNewsletterWidget(!this.showNewsletterWidget());
        }

    

        public submitNewsletterSubscription = (form) => {
            this.newsletterSubmitting(true); // activate submission state
            this.data.postForm("/Default.aspx?ID=" + this.newsletterFormID, $(form).serialize())
                .then((result) => {
                    localStorage.setItem("newsletterHide", "1");
                    this.newsletterSubscriptionStatus(true);
                    $(this.newsletterModal).modal();
                    this.showNewsletterWidget(false);
                    this.newsletterSubmitting(false); // de-activate submission state
                })
                .fail((error) => {
                    this.newsletterSubscriptionStatus(false);
                    $(this.newsletterModal).modal();
                    this.newsletterSubmitting(false); // de-activate submission state
                });
        }

        public toggleResponsiveMenu = () => {
            this.showResponsiveMenu(!this.showResponsiveMenu());
        }

        //Can be used to invoke login modal when user is not logged in
        public notLoggedIn() {
            if (this.User().IsLoggedIn()) {
                $('.loginModal').modal('show');
            }
        }

        public setCustomerType = (type) => {
            var d = new Date();
            d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = "CustomerType" + "=" + type + ";" + expires + ";path=/";
            location.reload();
        }

    }

    export class Load {
        public active = ko.observable(false);
        public text = ko.observable("");
    }
}
